import { render, staticRenderFns } from "./WebSiteInfo.vue?vue&type=template&id=2f8ed615&scoped=true&"
import script from "./WebSiteInfo.vue?vue&type=script&lang=js&"
export * from "./WebSiteInfo.vue?vue&type=script&lang=js&"
import style0 from "./WebSiteInfo.vue?vue&type=style&index=0&id=2f8ed615&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8ed615",
  null
  
)

export default component.exports